export default "__VITE_ASSET__DRbZWeFP__"